(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2532],{

/***/ 15800:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game/[slug]",
      function () {
        return __webpack_require__(86038);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Games; },
/* harmony export */   "_": function() { return /* binding */ GAME_PROVIDER_SHORTCODES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45362);





var ExternalGame = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 327).then(__webpack_require__.bind(__webpack_require__, 60487));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60487)
            ];
        }
    }
});
var Raffle = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7554), __webpack_require__.e(8336)]).then(__webpack_require__.bind(__webpack_require__, 78336));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78336)
            ];
        }
    }
});
var ScratchAndWin = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7554), __webpack_require__.e(9735), __webpack_require__.e(8317)]).then(__webpack_require__.bind(__webpack_require__, 28317));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28317)
            ];
        }
    }
});
var Trivia = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(5419), __webpack_require__.e(7935), __webpack_require__.e(4231), __webpack_require__.e(7554), __webpack_require__.e(302), __webpack_require__.e(6079)]).then(__webpack_require__.bind(__webpack_require__, 86079));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86079)
            ];
        }
    }
});
var Voting = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7935), __webpack_require__.e(7554), __webpack_require__.e(8670)]).then(__webpack_require__.bind(__webpack_require__, 20935));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20935)
            ];
        }
    }
});
var SlotMachine = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7554), __webpack_require__.e(3680), __webpack_require__.e(7971)]).then(__webpack_require__.bind(__webpack_require__, 27971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27971)
            ];
        }
    }
});
// TODO: enable when games are available
// const SpinTheWheel = dynamic(() => import('components/@game/InternalGame/SpinTheWheel'));
var Games = function(game) {
    switch(game.type){
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.scratch */ .f2.scratch:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScratchAndWin, {
                game: game
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.quiz */ .f2.quiz:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Trivia, {
                id: game.id,
                slug: game.slugName
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.vote */ .f2.vote:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Voting, {
                id: game.id,
                slug: game.slugName
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.raffle */ .f2.raffle:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Raffle, {
                id: game.id,
                slug: game.slugName
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.slot */ .f2.slot:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SlotMachine, {
                id: game.id,
                slug: game.slugName
            });
        // case TypeOfGame.wheel:
        //   return <SpinTheWheel id={game.id} slug={game.slugName} />;
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.webview */ .f2.webview:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExternalGame, {
                game: game
            });
        default:
            return null;
    }
};
var _obj;
var GAME_PROVIDER_SHORTCODES = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .GameProvider.Newcom */ .Ui.Newcom, ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .GameProvider.Gameloft */ .Ui.Gameloft, "18764442404"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .GameProvider.Nazara */ .Ui.Nazara, "18764442484"), _obj);


/***/ }),

/***/ 86038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(28889);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./src/hooks/useBackRouter.ts
var useBackRouter = __webpack_require__(28775);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/queries/games/detail/useGetGameDetails.ts
var useGetGameDetails = __webpack_require__(96420);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/services/api/ApiService.ts + 19 modules
var ApiService = __webpack_require__(58416);
// EXTERNAL MODULE: ./src/services/notifications/useBadgeNotification.ts
var useBadgeNotification = __webpack_require__(77006);
// EXTERNAL MODULE: ./src/services/notifications/usePointsNotification.tsx + 1 modules
var usePointsNotification = __webpack_require__(64075);
;// CONCATENATED MODULE: ./src/queries/games/usePlayGame.ts





var usePlayGame = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var showBadgeNotification = (0,useBadgeNotification/* useBadgeNotification */.x)().showBadgeNotification;
    var showNotification = (0,usePointsNotification/* usePointsNotification */.Q)().showNotification;
    var mutate = (0,es.useMutation)(function(param) {
        var id = param.id, name = param.name;
        return ApiService/* default.startGame */.Z.startGame(id, name);
    }, (0,_object_spread/* default */.Z)({}, options)).mutate;
    var startGame = (0,react.useCallback)(function(params) {
        mutate(params, {
            onSuccess: function(data) {
                var ref;
                if (data && !!data.pointsGained.length) {
                    data.pointsGained.forEach(function(notification, idx) {
                        // Because notistack doesn't support queing https://github.com/iamhosseindhv/notistack/issues/204
                        // We just delay the notification until the auto hide has been triggered
                        setTimeout(function() {
                            showNotification(notification, 5000);
                        }, 6000 * idx);
                    });
                }
                var _length;
                var pointsNotificationsCount = (_length = data === null || data === void 0 ? void 0 : data.pointsGained.length) !== null && _length !== void 0 ? _length : 0;
                if (data && !!((ref = data.badgesEarned) === null || ref === void 0 ? void 0 : ref.length)) {
                    setTimeout(function() {
                        data.badgesEarned.forEach(function(notification) {
                            showBadgeNotification(notification);
                        });
                    }, pointsNotificationsCount * 6000);
                }
            }
        });
    }, [
        mutate,
        showNotification,
        showBadgeNotification
    ]);
    return {
        startGame: startGame
    };
};

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(68711);
// EXTERNAL MODULE: ./src/utils/routes.utils.ts
var routes_utils = __webpack_require__(24039);
// EXTERNAL MODULE: ./src/constants/games.tsx
var games = __webpack_require__(51222);
// EXTERNAL MODULE: ./src/services/api/definitions/game.definitions.ts
var game_definitions = __webpack_require__(45362);
// EXTERNAL MODULE: ./src/components/@layout/NavigationLayout/NavigationLayout.tsx + 12 modules
var NavigationLayout = __webpack_require__(18039);
;// CONCATENATED MODULE: ./src/pages/game/[slug].tsx












var Game = function(param) {
    var _id = param.id, id = _id === void 0 ? "" : _id;
    var intl = (0,useIntl/* default */.Z)();
    var game = (0,useGetGameDetails/* useGetGameDetails */.i)(id).game;
    var startGame = usePlayGame().startGame;
    (0,react.useEffect)(function() {
        if (game && game.id && game.name) {
            startGame({
                id: game.id,
                name: game.name
            });
        }
    }, [
        game,
        startGame
    ]);
    var router = (0,useBackRouter/* useBackRouter */.k)(game ? (0,routes_utils/* generatePath */.G)(routes/* Routes.gameDetails */.Z.gameDetails, {
        slug: game.slugName
    }) : undefined);
    if (router.isFallback || !game || game.contentType === game_definitions/* ContentType.subscription */.zc.subscription) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                size: 24
            })
        });
    }
    var gameToRender = (0,games/* Games */.O)(game);
    var type = game.gameType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationLayout/* default */.Z, {
        gameType: game.gameType,
        behaviour: "fixed",
        hideBottomNavigation: true,
        backAction: router.back,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: intl.formatMessage({
                    id: "seo.title.game.slug"
                }, {
                    game: game.name
                }),
                description: game.description,
                openGraph: {
                    images: [
                        {
                            url: game.largeTeaserImage
                        }
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                style: {
                    height: "100%"
                },
                children: [
                    type === game_definitions/* GameType.thirdParty */.D$.thirdParty && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        maxWidth: "sm",
                        disableGutters: true,
                        style: {
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            children: gameToRender
                        })
                    }),
                    type === game_definitions/* GameType.firstParty */.D$.firstParty && gameToRender
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Game);


/***/ }),

/***/ 96420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useGetGameDetails; }
/* harmony export */ });
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11777);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58416);



var useGetGameDetails = function(id) {
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queries__WEBPACK_IMPORTED_MODULE_1__/* .QueryKeys.gamedetail.byId */ .i.gamedetail.byId(id), function() {
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getGameDetails */ .Z.getGameDetails(id);
    }, {
        enabled: !!id
    }), game = ref.data, isLoading = ref.isLoading;
    return {
        isLoading: isLoading,
        game: game
    };
};


/***/ }),

/***/ 24039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ generatePath; }
/* harmony export */ });
/* unused harmony export enhancePathsWithLocales */
/* harmony import */ var path_to_regexp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51068);

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Keep cache of PathFunctions
    if (cache[path]) return cache[path];
    var generator = (0,path_to_regexp__WEBPACK_IMPORTED_MODULE_0__/* .compile */ .MY)(path, options);
    if (cacheCount < cacheLimit) {
        // populate cache
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Generates a valid path you can use for manually pushing to routes.
 * e.g. "/users/:id" > generatePath("/users/:id", { id: 1 }) > "/users/1"
 */ function generatePath() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/", params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return path === "/" ? path : compilePath(path)(params);
}
function enhancePathsWithLocales(paths, locales) {
    if (!locales) {
        return paths;
    }
    var localePaths = [];
    paths.forEach(function(p) {
        locales.forEach(function(l) {
            localePaths.push({
                params: p.params,
                locale: l
            });
        });
    });
    return localePaths;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9282,8500,8039,9774,2888,179], function() { return __webpack_exec__(15800); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);